import React, { useState, useEffect } from "react";
import useQueryParams from "../../../hooks/useQueryParams";
import { useUI } from "../../../context/ui";
import { NavLink, useLocation } from "react-router-dom";
import { API_URL } from "../../../utilities/constants";
import PageTitle from "../../../components/common/PageTitle";
import FullPageLoader from "../../../components/ui/FullPageLoader";
import { formatDateTime } from "../../../utilities/helpers";
import RSModal from "../../../components/ui/RSModal";
import ButtonTertiary from "../../../components/ui/ButtonTertiary";
import ViewTemplatePopUp from "../CustomerNotif/TempleteDetails";
import Pagination from "../../../components/common/Pagination";
import { FaCheckCircle, FaHourglassHalf, FaTimesCircle } from "react-icons/fa";
const buildQueryParams = (params) =>
  Object.entries(params)
    .filter(([_, value]) => value !== "")
    .map(([key, value]) => `${key}=${value}`)
    .join("&");

const STATUS_STYLES = {
  sending: { backgroundColor: "rgba(243, 243, 142, 0.56)", color: "#FF7A33" },
  sent: { backgroundColor: "#D1FAE5", color: "#047857" },
  failed: { backgroundColor: "#FEE2E2", color: "#DC2626" },
};

const StatusIndicator = ({ icon, count, type }) => {
  return (
    <div
      style={{
        display: "flex",
        height: "25px",
        alignItems: "center",
        padding: "10px",
        width: "150px",
        borderRadius: "8px",
        ...STATUS_STYLES[type],
      }}
    >
      <span
        style={{
          marginRight: "8px",
        }}
      >
        {icon}
      </span>
      <span style={{ fontWeight: "400", color: "#374151" }}>
        {type.charAt(0).toUpperCase() + type.slice(1)}
      </span>
      <span
        style={{
          marginLeft: "auto",
          fontSize: "18px",
        }}
      >
        {count}
      </span>
    </div>
  );
};

const AppNotificationHistory = () => {
  const { updateQueryParam, queryParams } = useQueryParams();
  const tab = queryParams.get("tab") || "app";
  const section = queryParams.get("section") || "history";
  const pageNo = queryParams.get("pageNo") || 0;
  const pageSize = queryParams.get("pageSize") || 10;
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [notificationHistory, setNotificationHistory] = useState([]);
  const location = useLocation();

  const { setSegmentTitle, addToastMessage } = useUI();
  useEffect(() => {
    setSegmentTitle("App Notification");
  }, [location.search]);

  const fetchNotificationHistory = async () => {
    setLoading(true);
    try {
      const query = buildQueryParams({
        pageNo: pageNo,
        pageSize: pageSize,
      });
      const response = await fetch(
        API_URL + `/api/1.0.0/notification?sortOrder=DESC&${query}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "X-JWT-Assertion": localStorage.getItem("token"),
          },
        }
      );

      if (!response.ok) {
        setLoading(false);
        throw new Error("Failed to fetch templates");
      }

      const resp = await response.json();
      setNotificationHistory(resp.data);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching templates:", error);
    }
  };

  useEffect(() => {
    fetchNotificationHistory();
  }, [location]);

  return (
    <>
      <PageTitle title="App Notification" />
      <FullPageLoader isActive={loading} />
      <div className="rs-table-holder">
        <table className="rs-table">
          <thead>
            <tr>
              <th>#</th>
              <th>Sent By</th>
              <th>Sent At</th>
              <th>Template Subject</th>
              <th>Users</th>
              <th>Total Users</th>
              <th>Stats</th>
              <th>
                <p className="flex center-center">Action</p>
              </th>
            </tr>
          </thead>
          {notificationHistory && (
            <tbody>
              {notificationHistory.list?.map((d, i) => (
                <tr key={i}>
                  <td>
                    {notificationHistory.pageNo * notificationHistory.pageSize +
                      i +
                      1}
                  </td>
                  <td>{d?.createdBy || "-"}</td>
                  <td>{d?.createdAt ? formatDateTime(d.createdAt) : "-"}</td>
                  <td>
                    <p
                      style={{
                        width: "190px",
                        overflow: "hidden",
                        whiteSpace: "nowrap",
                        textOverflow: "ellipsis",
                      }}
                    >
                      {d?.templateSubject || "-"}
                    </p>
                  </td>
                  <td>
                    {d?.userNames || "-"}
                    {d?.totalUsers > 2
                      ? ` and ${parseInt(d.totalUsers) - 2} more...`
                      : ""}
                  </td>
                  <td>
                    <p style={{ textAlign: "center" }}>
                      {d?.totalUsers || "-"}
                    </p>
                  </td>

                  <td>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "8px",
                      }}
                    >
                      <StatusIndicator
                        icon={<FaCheckCircle style={{ height: "12px" }} />}
                        count={d?.successCount}
                        type="sent"
                      />
                      <StatusIndicator
                        icon={<FaHourglassHalf style={{ height: "12px" }} />}
                        count={d?.inProgressCount}
                        type="sending"
                      />
                      <StatusIndicator
                        icon={<FaTimesCircle style={{ height: "12px" }} />}
                        count={d?.failedCount}
                        type="failed"
                      />
                    </div>
                  </td>
                  <td>
                    <div className="flex center-center" style={{ gap: "12px" }}>
                      <div>
                        <ButtonTertiary
                          title="View"
                          actionType="view"
                          onClick={() => {
                            updateQueryParam("groupid", d?.groupId);
                          }}
                        />
                      </div>
                    </div>
                  </td>
                </tr>
              ))}

              {(!notificationHistory.list ||
                notificationHistory.list.length === 0) &&
                !loading && (
                  <tr>
                    <td
                      colSpan={8}
                      style={{
                        textAlign: "center",
                        padding: "10px",
                      }}
                    >
                      <p> No records found. </p>
                    </td>
                  </tr>
                )}
            </tbody>
          )}
        </table>
      </div>
      {notificationHistory && (
        <Pagination
          totalRecords={notificationHistory.totalRecords}
          pageNo={notificationHistory.pageNo}
          pageSize={notificationHistory.pageSize}
          baseUrl={`/marketing?tab=app&section=history&`}
        />
      )}
    </>
  );
};

export default AppNotificationHistory;
